goog.module('yext.entity.edit.EntityClusterGuard');
goog.module.declareLegacyNamespace();

/**
 * Displays a cluster guard message when making changes to an entity
 *
 * @author Sean Egan (segan@yext.com)
 */
const EntityClusterGuard = class {
  constructor(field, entityCluster) {
    this.field = field;
    this.fieldOriginalAction = field.action;
    this.entityCluster = entityCluster;

    this.bindFormBeforeSubmit();
    this.bindFormAlways();
  }

  /**
   * Binds the beforeSubmit.field event to open the correct cluster guard dialog
   */
  bindFormBeforeSubmit() {
    if (this.entityCluster.isIncompleteCluster) {
      this.field.$form.on('beforeSubmit.field', () => this.handleIncompleteCluster());
    } else if (this.entityCluster.hasMultipleClusters) {
      this.field.$form.on('beforeSubmit.field', () => this.handleMultipleClusters());
    } else {
      this.field.$form.on('beforeSubmit.field', () => {});
    }
  }

  /**
   * Binds the always.field event to reset the field's action
   */
  bindFormAlways() {
    this.field.$form.on('always.field', () => {
      this.field.action = this.fieldOriginalAction;
    });
  }

  /**
   * Displays the incomplete cluster dialog
   */
  handleIncompleteCluster() {
    this.field.preventDefault();

    yext.location.cluster.dialog.incomplete({
      onUpdate: () => {
        if (this.field.submitForm) {
          this.field.submitForm(this.field.action);
        } else {
          this.submitForm();
        }
      },
      onUpdateAllSubmit: () => this.setFieldAction(this.entityCluster.clusterUpdateUrl),
      onCancel: () => this.field.enableSubmit(),
    });
  }

  /**
   * Displays the multiple cluster dialog
   */
  handleMultipleClusters() {
    this.field.preventDefault();

    yext.location.cluster.dialog.multiple({
      onUpdate: () => this.submitForm(),
    });
  }

  /**
   * Updates the action URL for the field
   */
  setFieldAction(action) {
    this.field.action = action;
  }

  /**
   * Submits the field form
   */
  submitForm() {
    if (this.field.files.length) {
      this.field.submitWithFiles();
    } else {
      this.field.submit();
    }
  }
};

exports = EntityClusterGuard;
